module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page album-stats-page"
  }, [(_vm.isPageReady) ? _c('v-flex', {
    staticClass: "album-section",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Stats")]), _vm._v(" "), _c('div', {
    staticClass: "album-info-section"
  }, [_c('div', {
    staticClass: "album-cover-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.thumb.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-detail-section"
  }, [_c('p', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n          By\n          "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.album.user.slug
    }
  }, [_vm._v(_vm._s(_vm.album.user.username))])], 1), _vm._v(" "), _c('p', {
    staticClass: "album-stats"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.album.stats.plays_size)))]), _c('label', [_vm._v("Plays")])])])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('div', {
    staticClass: "normal-tab"
  }, [_c('v-tabs', {
    attrs: {
      "black": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, _vm._l((_vm.activities), function(activity) {
      return _c('activity-item', {
        key: activity.id,
        attrs: {
          "activityItem": activity
        }
      })
    }))], 1)
  }))], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104423d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/album_stats.vue
// module id = 1612
// module chunks = 180